import { defineMessages } from '@sm/intl';
import PROJECT_NAME from '~app/pages/Pricing/constants/project';

const PRICING_DISCLAIMER = '[Type: String][Vis.: high] - A string in pricing footer disclaimer';

const COPY = defineMessages({
  BUY_RESPONSES: {
    id: 'Pricing.copy.BuyResponses',
    defaultMessage: 'BUY TARGETED RESPONSES',
    desc: {
      id: 'Pricing.copy.BuyResponses',
      message: '[Type: Button][Vis.: high] - A button/link text on pricing footer',
      project: PROJECT_NAME,
    },
  },
  ADVANCE_SURVEY: {
    id: 'Pricing.copy.AdvanceSurvey',
    defaultMessage: 'Advanced survey design and analysis features are included in the price of your Audience project.',
    desc: {
      id: 'Pricing.copy.AdvanceSurvey',
      message: '[Type: String][Vis.: high] - A string above pricing footer list',
      project: PROJECT_NAME,
    },
  },
  TARGET_PEOPLE: {
    id: 'Pricing.copy.TargetPeople',
    defaultMessage:
      'Target the types of people you want to hear from based on specific attributes, like country, gender, age, income, employment status, and more.',
    desc: {
      id: 'Pricing.copy.TargetPeople',
      message: '[Type: String][Vis.: high] - A string above pricing footer cta',
      project: PROJECT_NAME,
    },
  },
  SURVEY_RESPONSES: {
    id: 'Pricing.copy.SurveyResponses',
    defaultMessage:
      'Get survey responses from around the world in minutes with <span id="audience">SurveyMonkey Audience</span>',
    desc: {
      id: 'Pricing.copy.SurveyResponses',
      message: '[Type: String][Vis.: high] - A string in pricing footer below header',
      project: PROJECT_NAME,
    },
  },
  PAID_FEATURES: {
    id: 'Pricing.copy.PaidFeatures',
    defaultMessage: 'SurveyMonkey Audience includes access to Paid Features',
    desc: {
      id: 'Pricing.copy.PaidFeatures',
      message: '[Type: Header][Vis.: high] - A string in pricing footer header',
      project: PROJECT_NAME,
    },
  },
  DISPLAYED_PRICING: {
    id: 'Pricing.copy.DisplayedPricingDisclaimer',
    defaultMessage:
      '*Displayed pricing represents a {teamsMinimumDiscount}% or more savings per user per month compared to individual Advantage and Premier plans',
    desc: {
      id: 'Pricing.copy.DisplayedPricingDisclaimer',
      message: PRICING_DISCLAIMER,
      project: PROJECT_NAME,
    },
  },
  PER_ADDITIONAL_RESPONSE: {
    id: 'Pricing.copy.PerAddResponseDisclaimer',
    defaultMessage: '**{overageCost} per additional response. SurveyMonkey Audience responses sold separately',
    desc: {
      id: 'Pricing.copy.PerAddResponseDisclaimer',
      message: PRICING_DISCLAIMER,
      project: PROJECT_NAME,
    },
  },
  ADD_ON_FEATURES: {
    id: 'Pricing.copy.AddOnFeaturesDisclaimer',
    defaultMessage: '***Add-on features available with Enterprise plan must be purchased separately',
    desc: {
      id: 'Pricing.copy.AddOnFeaturesDisclaimer',
      message: PRICING_DISCLAIMER,
      project: PROJECT_NAME,
    },
  },
  BASICS: {
    id: 'Pricing.copy.Basics',
    defaultMessage: 'Just need the basics?',
    desc: {
      id: 'Pricing.copy.Basics',
      message: '[Type: String][Vis.: high] - A string asking if the user is only interested in the basics',
      project: PROJECT_NAME,
    },
  },
  GET_STARTED: {
    id: 'Pricing.copy.GetStarted',
    defaultMessage: 'Get started for free.',
    desc: {
      id: 'Pricing.copy.GetStarted',
      message: '[Type: Link][Vis.: high] - A link to sign up page ',
      project: PROJECT_NAME,
    },
  },
  ALL_FEATURES: {
    id: 'Pricing.copy.AllFeatures',
    defaultMessage: 'SEE ALL PLAN FEATURES',
    desc: {
      id: 'Pricing.copy.AllFeatures',
      message: '[Type: Link][Vis.: high] - A link to details page',
      project: PROJECT_NAME,
    },
  },
  MORE: {
    id: 'Pricing.copy.More',
    defaultMessage: 'More about plans and pricing',
    desc: {
      id: 'Pricing.copy.More',
      message: '[Type: Header][Vis.: high] - More info about plans and pricing',
      project: PROJECT_NAME,
    },
  },
  SEE_PRICING: {
    id: 'Pricing.copy.SeePricing',
    defaultMessage: 'See pricing',
    desc: {
      id: 'Pricing.copy.SeePricing',
      message: '[Type: Link][Vis.: high] - A link to pricing',
      project: PROJECT_NAME,
    },
  },
  SPECIAL_PRICING_FOR_EDUCATORS_FAQ: {
    id: 'Pricing.copy.SpecialPricingForEducatorsFaq',
    defaultMessage: 'Do you offer special pricing for students or educators?',
    desc: {
      id: 'Pricing.copy.SpecialPricingForEducatorsFaq',
      message: '[Type: Title][Vis.: high] - A string for special pricing for educators and students faq',
      project: PROJECT_NAME,
    },
  },
  SPECIAL_PRICING_FOR_EDUCATORS_ANSWER: {
    id: 'Pricing.copy.SpecialPricingForEducatorsAnswer',
    defaultMessage: 'Yes! We offer discounted pricing for students and educators.',
    desc: {
      id: 'Pricing.copy.SpecialPricingForEducatorsAnswer',
      message: '[Type: String][Vis.: high] - A string for special pricing for educators and students answer',
      project: PROJECT_NAME,
    },
  },
  DISCOUNTS_FOR_TEAMS_FAQ: {
    id: 'Pricing.copy.DiscountForTeamsFaq',
    defaultMessage: 'Do you offer discounts for teams?',
    desc: {
      id: 'Pricing.copy.DiscountForTeamsFaq',
      message: '[Type: Title][Vis.: high] - A string for discounts for teams faq',
      project: PROJECT_NAME,
    },
  },
  DISCOUNTS_FOR_TEAMS_ANSWER: {
    id: 'Pricing.copy.DiscountForTeamsAnswer',
    defaultMessage:
      'We offer discounts when you sign up for team plans that include 3 or more people. With Team Advantage and Team Premier plans, you’ll save {teamsMinimumDiscount}% or more over individual plans and get access to additional collaboration features.',
    desc: {
      id: 'Pricing.copy.DiscountForTeamsAnswer',
      message: '[Type: String][Vis.: high] - A string for discounts for teams answer',
      project: PROJECT_NAME,
    },
  },
  CORPORATE_PLANS_FAQ: {
    id: 'Pricing.copy.CorporatePlansFaq',
    defaultMessage: 'Do you offer plans for corporate needs?',
    desc: {
      id: 'Pricing.copy.CorporatePlansFaq',
      message: '[Type: Title][Vis.: high] - A string for corporate plans faq',
      project: PROJECT_NAME,
    },
  },
  CORPORATE_PLANS_ANSWER: {
    id: 'Pricing.copy.CorporatePlansAnswer',
    defaultMessage:
      'Our Enterprise plans offer HIPAA compliance, advanced security, and admin features for increased governance and control.',
    desc: {
      id: 'Pricing.copy.CorporatePlansAnswer',
      message: '[Type: String][Vis.: high] - A string for corporate plans answer',
      project: PROJECT_NAME,
    },
  },
  CONTACT_SALES: {
    id: 'Pricing.copy.ContactSales',
    defaultMessage: 'Contact sales',
    desc: {
      id: 'Pricing.copy.ContactSales',
      message: '[Type: Link][Vis.: high] - A link to contact sales',
      project: PROJECT_NAME,
    },
  },

  // FEATURE COPY FOR AUDIENCE MODULE
  AUDIENCE_NUMBER_OF_SURVEYS: {
    id: 'Pricing.copy.NumberOfSurveys',
    defaultMessage: 'Unlimited number of surveys',
    desc: {
      id: 'Pricing.copy.NumberOfSurveys',
      message: '[Type: String][Vis.: high] - Number of surveys feature string',
      project: PROJECT_NAME,
    },
  },
  AUDIENCE_QUESTIONS_PER_SURVEY: {
    id: 'Pricing.copy.QuestionsPerSurvey',
    defaultMessage: '50 questions per survey',
    desc: {
      id: 'Pricing.copy.QuestionsPerSurvey',
      message: '[Type: String][Vis.: high] - questions per survey feature string',
      project: PROJECT_NAME,
    },
  },
  AUDIENCE_UNLIMITED_RESPONSES: {
    id: 'Pricing.copy.UnlimitedResponses',
    defaultMessage: 'Unlimited responses',
    desc: {
      id: 'Pricing.copy.UnlimitedResponses',
      message: '[Type: String][Vis.: high] - An Unlimited Responses feature string',
      project: PROJECT_NAME,
    },
  },
  AUDIENCE_EMAIL_SUPPORT: {
    id: 'Pricing.copy.EmailSupport',
    defaultMessage: '24/7 customer support via email',
    desc: {
      id: 'Pricing.copy.EmailSupport',
      message: '[Type: String][Vis.: high] - An Email Support feature string',
      project: PROJECT_NAME,
    },
  },
  AUDIENCE_CUSTOMIZATION: {
    id: 'Pricing.copy.SurveyCustomization',
    defaultMessage: 'Custom colors & survey URL',
    desc: {
      id: 'Pricing.copy.SurveyCustomization',
      message: '[Type: String][Vis.: high] - A Survey Customization feature string',
      project: PROJECT_NAME,
    },
  },
  AUDIENCE_DATA_EXPORTS: {
    id: 'Pricing.copy.DataExports',
    defaultMessage: 'Data exports (CSV, PDF, PPT, XLS)',
    desc: {
      id: 'Pricing.copy.DataExports',
      message: '[Type: String][Vis.: high] - A Data Exports feature string',
      project: PROJECT_NAME,
    },
  },
  AUDIENCE_SKIP_LOGIC: {
    id: 'Pricing.copy.SkipLogic',
    defaultMessage: 'Skip logic',
    desc: {
      id: 'Pricing.copy.SkipLogic',
      message: '[Type: String][Vis.: high] - A SkipLogic feature string',
      project: PROJECT_NAME,
    },
  },
  AUDIENCE_PIPING: {
    id: 'Pricing.copy.QuestionAnswerPiping',
    defaultMessage: 'Question & answer piping',
    desc: {
      id: 'Pricing.copy.QuestionAnswerPiping',
      message: '[Type: String][Vis.: high] - A Question Answer Piping feature string',
      project: PROJECT_NAME,
    },
  },
  AUDIENCE_FILE_UPLOAD: {
    id: 'Pricing.copy.FileUpload',
    defaultMessage: 'File upload',
    desc: {
      id: 'Pricing.copy.FileUpload',
      message: '[Type: String][Vis.: high] - A File Upload feature string',
      project: PROJECT_NAME,
    },
  },
  AUDIENCE_A_B_TESTING: {
    id: 'Pricing.copy.ABTesting',
    defaultMessage: 'A/B test text and images',
    desc: {
      id: 'Pricing.copy.ABTesting',
      message: '[Type: String][Vis.: high] - An ABTesting feature string',
      project: PROJECT_NAME,
    },
  },
  AUDIENCE_HIDE_FOOTER: {
    id: 'Pricing.copy.HideFooter',
    defaultMessage: 'Hide SurveyMonkey footer',
    desc: {
      id: 'Pricing.copy.HideFooter',
      message: '[Type: String][Vis.: high] - Hide SurveyMonkey footer feature string',
      project: PROJECT_NAME,
    },
  },
  AUDIENCE_MULTILINGUAL: {
    id: 'Pricing.copy.MultilingualSurveys',
    defaultMessage: 'Multilingual surveys',
    desc: {
      id: 'Pricing.copy.MultilingualSurveys',
      message: '[Type: String][Vis.: high] - Multilingual Surveys feature string',
      project: PROJECT_NAME,
    },
  },
});

export default COPY;
